import left from './assets/left-card.png';
import right from './assets/right-card.png';
import './gameCard.css';
export const gameCard = { left, right };
